import styles from "./PageLoader.module.css";
import logo from "../../assets/navigation/logo-vertical.png";
import Loader from "../UI/Loader";

export default function PageLoader() {
  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <img className={styles.logo} src={logo} />
        <div className={styles[`loader`]}>
          <Loader />
        </div>
      </div>
    </main>
  );
}
